import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ggs } from 'src/app/core/translations/ggs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-guru-granth-sahib',
  templateUrl: './guru-granth-sahib.component.html',
  styleUrls: ['./guru-granth-sahib.component.scss']
})
export class GuruGranthSahibComponent implements OnInit {

  isHandsetPortrait: boolean = false;

  currentLanguage: string = '';
  bannerImage: any ='';
  bannerClass: any ='';
  languageTranslations: any = ggs;
  activeLanguageTranslations: any = {};
  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {


    this.bannerClass = environment.pageClass;
    this.bannerImage = environment.staticPageBanner;


    if (this.route.snapshot.paramMap.get('language')) {
    	// console.log('f');
      let language: string | null =
        this.route.snapshot.paramMap.get('language');

      if (language) {

        this.activeLanguageTranslations = this.languageTranslations[language];

        // console.log(this.activeLanguageTranslations);
      }
    }
  }

  goToPage(pageName: string) {
    this.router.navigate([`/${pageName}`]);
  }

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

}
